import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import { addAccountsList } from 'Workspace/Admin/store/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection) {
  const workspaceAccountsList = yield call(connection.fetch.bind(connection), constants.RTM_IAM_SUBSCRIPTION_USER_LIST);
  if (workspaceAccountsList.type === constants.RTM_IAM_SUBSCRIPTION_USER_LIST_OK) {
    const accounts = workspaceAccountsList.response.accounts;
    yield put(addAccountsList(accounts));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceAccountsList} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_ACCOUNTS_LIST, catchErrors, sendRequest, connection);
}
